var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCdsOnboardingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 173,
    viewBox: "0 0 375 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_93824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-118.554 279.558L-85.0132 257.145C-51.472 234.732 7.01802 157.624 80.8735 124.058C154.856 90.7029 264.141 114.031 346.582 94.7389C428.832 75.1293 491.41 26.5795 570.258 1.31328C649.106 -23.9529 724.605 -38.5476 761.421 -55.5157L798.365 -72.2723L727.137 -190.691L752.065 -332.909C713.436 -318.954 675.445 -387.185 598.187 -359.275C520.929 -331.366 407.015 -402.997 329.757 -375.088C252.499 -347.178 27.8703 -440.865 -49.3876 -412.956C-126.645 -385.046 -97.1138 -134.96 -135.743 -121.006L-199.958 144.223L-118.554 279.558Z",
    fill: "#B6E0EC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.894 253.779L-111.353 231.366C-77.8119 208.953 -19.3218 131.844 54.5336 98.2783C128.516 64.9237 237.801 88.252 320.242 68.9596C402.492 49.35 465.07 0.800175 543.918 -24.466C622.766 -49.7322 698.265 -64.3269 735.081 -81.295L772.025 -98.0516L700.797 -216.47L725.725 -358.688C687.096 -344.733 649.105 -412.964 571.847 -385.055C494.589 -357.145 380.675 -428.777 303.417 -400.867C226.159 -372.958 1.53047 -466.645 -75.7274 -438.735C-152.985 -410.826 -123.454 -160.74 -162.083 -146.785L-226.298 118.444L-144.894 253.779Z",
    fill: "#B6E0EC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.422 232.57L-91.8807 210.157C-58.3394 187.744 0.150587 110.636 74.0061 77.0695C147.989 43.7149 257.273 67.0433 339.715 47.7509C421.965 28.1413 484.543 -20.4086 563.39 -45.6748C642.238 -70.941 717.737 -85.5356 754.554 -102.504L791.497 -119.26L720.269 -237.679L745.198 -379.897C706.569 -365.942 668.578 -434.173 591.32 -406.263C514.062 -378.354 400.148 -449.985 322.89 -422.076C245.632 -394.166 21.0029 -487.853 -56.255 -459.944C-133.513 -432.035 -103.981 -181.948 -142.61 -167.994L-206.826 97.2348L-125.422 232.57Z",
    fill: "#B6E0EC",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.324 219.381L-84.783 196.968C-51.2418 174.554 7.24824 97.4462 81.1037 63.8801C155.086 30.5255 264.371 53.8538 346.812 34.5614C429.062 14.9518 491.64 -33.598 570.488 -58.8642C649.336 -84.1304 724.835 -98.7251 761.651 -115.693L798.595 -132.45L727.367 -250.868L752.295 -393.086C713.666 -379.131 675.675 -447.362 598.417 -419.453C521.159 -391.543 407.245 -463.175 329.987 -435.265C252.73 -407.356 28.1005 -501.043 -49.1574 -473.133C-126.415 -445.224 -96.8836 -195.138 -135.513 -181.183L-199.728 84.0453L-118.324 219.381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_93824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 188,
    fill: "white",
    transform: "matrix(-1 0 0 -1 375 188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCdsOnboardingMobile);
export default __webpack_public_path__ + "static/media/bgCdsOnboardingMobile.4c42d7443a0c8bfa703ba2b7be116a21.svg";
export { ForwardRef as ReactComponent };